import { ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import routes from "./routes/routes";
import theme from "./utils/theme";

function App() {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <RouterProvider router={routes} />
      </ThemeProvider>
    </div>
  );
}

export default App;
